// removed by extract-text-webpack-plugin
module.exports = {"DeliveryProgress":"DeliveryProgress__DeliveryProgress__J-EAo"};


//////////////////
// WEBPACK FOOTER
// ./src/components/DeliveryProgress/DeliveryProgress.css
// module id = 199
// module chunks = 1